import React, { Component } from 'react';
import moment from 'moment';
import { convertToLocalTime } from '../../../utils/timeUtils';

class CanvasserListItem extends Component {
  render() {
    let { data, focused, id } = this.props;

    return (
      <div
        className={`side-menu-list-obj ${focused && 'focused'}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        id={id}
        onClick={this.props.onTitleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper" style={{ borderLeftColor: data.color }}>
          <div className="obj-title" onClick={this.props.onTitleClick}>
            {data.firstname} {data.lastname}
          </div>
          {this.props.showTimes && (
            <>
              <div className="obj-data">
                Login:{' '}
                {data.last_login ? convertToLocalTime(moment(data.last_login)).fromNow() : '--'}
              </div>
              <div className="obj-data">
                Checkin:{' '}
                {data.last_checkin ? convertToLocalTime(moment(data.last_checkin)).fromNow() : '--'}
              </div>
              <div className="obj-data">
                Response:{' '}
                {data.last_logresponse
                  ? convertToLocalTime(moment(data.last_logresponse)).fromNow()
                  : '--'}
              </div>
              <div className="obj-data">
                Last Knock:{' '}
                {data.last_knock ? convertToLocalTime(moment(data.last_knock)).fromNow() : '--'}
              </div>
              {!!data.is_checked_in && <div className="obj-data">Checked in</div>}
            </>
          )}
          {![null, undefined].includes(data.num_response) && (
            <div className={'obj-data'}>
              Responses: <span className="primary-text">{data.num_response}</span>
            </div>
          )}
          {![null, undefined].includes(data.num_checkins) && (
            <div className={'obj-data'}>
              Check Ins: <span className="primary-text">{data.num_checkins}</span>
            </div>
          )}
          {![null, undefined].includes(data.num_sites_checked_into) && (
            <div className={'obj-data'}>
              Sites Checked Into:{' '}
              <span className="primary-text">{data.num_sites_checked_into}</span>
            </div>
          )}
          {![null, undefined].includes(data.door_targets_canvassed) && (
            <div className={'obj-data'}>
              Targets Canvassed: <span className="primary-text">{data.door_targets_canvassed}</span>
            </div>
          )}
          {![null, undefined].includes(data.households_canvassed) && (
            <div className={'obj-data'}>
              Household Canvassed: <span className="primary-text">{data.households_canvassed}</span>
            </div>
          )}
          {(!data.longitude || !data.latitude || data.bad_loc_on_last_update) && (
            <div className={'obj-data'} style={{ color: 'red' }}>
              <i className="fas fa-exclamation-triangle"></i> Bad Location Update
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CanvasserListItem;
